function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKusamaKsmLogo = function SvgKusamaKsmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 441 441"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000",
      strokeMiterlimit: 10
    },
    d: "M.5.5h440v440H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6 127.4c-5.2-4.1-11.4-9.7-22.7-11.1-10.6-1.4-21.4 5.7-28.7 10.4s-21.1 18.5-26.8 22.7-20.3 8.1-43.8 22.2-115.7 73.3-115.7 73.3l24 .3-107 55.1h10.7L48.2 312s13.6 3.6 25-3.6v3.3s127.4-50.2 152-37.2l-15 4.4c1.3 0 25.5 1.6 25.5 1.6a34.34 34.34 0 0 0 15.4 24.8c14.6 9.6 14.9 14.9 14.9 14.9s-7.6 3.1-7.6 7c0 0 11.2-3.4 21.6-3.1a82.64 82.64 0 0 1 19.5 3.1s-.8-4.2-10.9-7-20.1-13.8-25-19.8a28 28 0 0 1-4.1-27.4c3.5-9.1 15.7-14.1 40.9-27.1 29.7-15.4 36.5-26.8 40.7-35.7s10.4-26.6 13.9-34.9c4.4-10.7 9.8-16.4 14.3-19.8s24.5-10.9 24.5-10.9-15.3-13.3-20.2-17.2Z",
    style: {
      fill: "#fff"
    }
  }))));
};
export { SvgKusamaKsmLogo as ReactComponent };